export const MODULE_VIEW_EVENT = ({ actionlocation, otherEventOptions }) => ({
  name: 'page.module.view',
  data: {
    actionlocation,
    ...otherEventOptions
  }
});



// WEBPACK FOOTER //
// ./src/universal/components/EdapModuleView/events.js